import { gql } from '@apollo/client'

export default gql(`
    mutation updateModuleConfig($id: ID!, $value: [String], $module: String $project: String ) {
        updateModuleConfig(
            input: {
                id: $id
                value: $value
                module: $module
                project: $project
            },
        ) {
            id
            value
            module
        }
    }`
)
